import { DistrictDto, FieldOptionInterface, ProviderDto, EngagementStatusDto } from '@families-link/shared';
import { FilterValuesStrings, FilterValuesArrays } from '../pages/analytics.page';

function parseCommaSeparatedList(value?: string): string[] {
	return value
		? value
				.split(',')
				.map((item) => item.trim())
				.filter(Boolean)
		: [];
}

function parseCommaSeparatedIdsAsDtos<T>(value?: string): T[] {
	return parseCommaSeparatedList(value).map((id) => ({ _id: id } as T));
}

export const inverseTransformFilterValues = (
	filters: FilterValuesStrings,
	currentDistrict?: DistrictDto
): FilterValuesArrays => ({
	districts: parseCommaSeparatedIdsAsDtos<DistrictDto>(filters.districtIds),
	engagementType: parseCommaSeparatedList(filters.engagementTypes),
	duration: filters.duration
		? filters.duration
				.map((dateString) => (dateString ? new Date(dateString) : null))
				.filter((date): date is Date => date !== null)
		: [],
	schools: parseCommaSeparatedIdsAsDtos<FieldOptionInterface>(filters.schoolIds),
	programs: parseCommaSeparatedIdsAsDtos<FieldOptionInterface>(filters.programIds),
	services: parseCommaSeparatedIdsAsDtos<FieldOptionInterface>(filters.serviceIds),
	providers: parseCommaSeparatedIdsAsDtos<ProviderDto>(filters.providerIds),
	languages: parseCommaSeparatedList(filters.languages),
	engagementStatus: parseCommaSeparatedIdsAsDtos<EngagementStatusDto>(filters.engagementStatuses),
});
